import React from 'react';

import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Responsive } from 'components';

import { Menu } from './components/Menu';

import { getAdminMenuItems } from './AdminMenuItems';
import { logout } from 'domain/store/auth';

import './AdminLayout.scss';

interface AdminLayoutProps {
  className?: string;
}
export const AdminLayout = (
  props: React.PropsWithChildren<AdminLayoutProps>
) => {
  const { t } = useTranslation(['common', 'admin']);
  const adminMenuItems = getAdminMenuItems(t);
  const { push } = useHistory();
  const dispatch = useDispatch();

  const logoutUser = () => {
    dispatch(logout());
    push('/');
  };

  const optionsItems = [
    {
      items: {
        logout: {
          title: 'Cerrar sesión',
          onClick: logoutUser,
        },
      },
    },
  ];
  return (
    <Responsive>
      <React.Suspense fallback='loading...'>
        <div className='admin-layout'>
          <div className='header-container'>
            <Menu
              items={adminMenuItems}
              right={optionsItems}
              header='Sanidad UE'
              onChange={(key: string) => {}}
            />
          </div>
          <div className={`body-container ${props.className ?? ''}`}>{props.children}</div>
        </div>
      </React.Suspense>
    </Responsive>
  );
};
